<script setup lang="ts">
import { computed } from 'vue';
import { stripTags } from '../../../compliance-shared/services/sanitize';

const props = withDefaults(
  defineProps<{
    text?: string;
    maxLength?: number;
  }>(),
  {
    text: '',
    maxLength: 100,
  },
);

const textTruncated = computed(function () {
  let text = props.text;
  if (text.includes('<')) {
    text = stripTags(new DOMParser(), text.replaceAll('&nbsp;', ' '));
  }

  if (text.length > props.maxLength) {
    return text.slice(0, props.maxLength) + '...';
  } else {
    return text;
  }
});
</script>

<template>
  <span>{{ textTruncated }}</span>
</template>
